import moment from 'moment-jalaali'

export function useJalaaliDate() {
  const toJalaali = (gregorianDate: string) => {
    if (!gregorianDate) return ''
    try {
      return moment(gregorianDate).format('jYYYY/jMM/jDD')
    } catch (error) {
      console.error('Error converting date:', error)
      return gregorianDate
    }
  }

  const toGregorian = (year: number, month: number, day: number, hour: number, minute: number) => {
    return moment(`${year}/${month}/${day} ${hour}:${minute}:00`, 'jYYYY/jM/jD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
  }

  return {
    toJalaali,
    toGregorian,
  }
}
